import type { ILocalizedText } from '@platform/core/types';
import { findModuleDefinition } from '@platform/modularity/moduleDefinitionRegistry';

/** Опублікована назва типу запису з пакета модуля (без глобального шару й налаштувань простору); пакет ще не завантажено — undefined. */
export const publishedTypeName = (module: string, rt: string): ILocalizedText | undefined =>
  findModuleDefinition(module)?.recordTypes.find((r) => r.key === rt)?.name;
